import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Hexagon, Menu, X } from "lucide-react";

const NAV = [
  { label: "Services", id: "services" },
  { label: "Digital Twin", id: "digital-twin" },
  { label: "AI Workflow", id: "ai-workflow" },
  { label: "Teams", id: "teams" },
  { label: "Pricing", id: "pricing" },
  { label: "Docs", id: "docs" },
];

export const Navbar = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className="sticky top-0 z-50 glass border-b border-slate-800/80">
      <nav className="max-w-7xl mx-auto px-4 lg:px-8 py-3.5 flex items-center justify-between">
        <button onClick={() => navigate("/")} className="flex items-center gap-2.5 group" data-testid="nav-logo">
          <Hexagon className="w-7 h-7 text-emerald-400 group-hover:rotate-90 transition-transform duration-500" strokeWidth={2.2} />
          <span className="font-display text-xl font-bold tracking-tight text-white">Wiwi</span>
          <span className="hidden sm:inline text-[10px] font-mono uppercase tracking-widest text-emerald-400/80 border border-emerald-500/30 rounded px-1.5 py-0.5">Twin Engine</span>
        </button>

        <div className="hidden lg:flex items-center gap-7">
          {NAV.map((n) => (
            <button key={n.id} onClick={() => go(n.id)} data-testid={`nav-${n.id}`}
              className="text-sm text-slate-400 hover:text-emerald-400 transition-colors duration-200 font-medium">
              {n.label}
            </button>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-3">
          {user ? (
            <Button onClick={() => navigate("/workspace")} data-testid="nav-workspace-btn"
              className="rounded-full bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-semibold">
              Launch Workspace
            </Button>
          ) : (
            <>
              <button onClick={login} data-testid="nav-signin-btn" className="text-sm text-slate-300 hover:text-white transition-colors font-medium">
                Sign in
              </button>
              <Button onClick={login} data-testid="nav-launch-btn"
                className="rounded-full bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-semibold">
                Launch Workspace
              </Button>
            </>
          )}
        </div>

        <button className="lg:hidden text-slate-200" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </nav>

      {open && (
        <div className="lg:hidden border-t border-slate-800 px-4 py-4 space-y-3 glass" data-testid="nav-mobile-menu">
          {NAV.map((n) => (
            <button key={n.id} onClick={() => go(n.id)} className="block w-full text-left text-slate-300 py-1.5">{n.label}</button>
          ))}
          <Button onClick={user ? () => navigate("/workspace") : login} className="w-full rounded-full bg-emerald-500 text-slate-950 font-semibold">
            {user ? "Launch Workspace" : "Launch Workspace"}
          </Button>
        </div>
      )}
    </header>
  );
};
